import React, { FC } from 'react';
import Grid from '@material-ui/core/Grid';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'react-admin';
import { H3 } from '~/components';
import { ReceiptIcon as PartnersIcon } from '~/img';
import { Balance } from '~/types/account';
import BalancesTable from '~/components/ra/Accounts/BalancesTable';
import { getProfileTypeByResource } from '~/utils/profileType';

const useStyles = makeStyles((theme) => ({
  bottomSpacing: {
    paddingBottom: theme.spacing(2),
  },
  innerContent: {
    paddingLeft: theme.spacing(4),
  },
}));

const label = (key: string): string => `components.TransactionView.${key}`;

interface BalancesProps {
  balances: Balance[];
  resource: string;
}

const Balances: FC<BalancesProps> = ({ balances, resource }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(label(key));
  return (
    <>
      <H3 bottomSpacing={2} icon={<PartnersIcon />}>
        {t('accountBalances')}
      </H3>
      <Grid
        item
        container
        xs={12}
        className={cx(classes.bottomSpacing, classes.innerContent)}
        spacing={2}
      >
        <Grid item xs={12}>
          <BalancesTable
            balances={balances}
            withHeader={false}
            accountProfileType={getProfileTypeByResource(resource)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Balances;
